import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
import MainContent from '../components/MainContent/MainContent';
import React from 'react';

const MainPage = () => {
  return (
    <>
      <Header />
      <MainContent />
      <Footer />
    </>
  );
};

export default MainPage;
